import { IsNotEmpty, IsString, NotEquals } from 'class-validator';

export class NomenclaturePositionDeleteRequest {
    @IsString()
    @IsNotEmpty()
    @NotEquals('0')
    public uuid: string;

    constructor(data?: Partial<NomenclaturePositionDeleteRequest>) {
        this.uuid = data && data.uuid;
    }
}
